export default __webpack_public_path__ + "cbf4751d9d7f88ddac3c62ea71c00e01.svg";